"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactMeasure = _interopRequireDefault(require("react-measure"));

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var Title = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Title, _React$Component);

  function Title() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Title);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Title)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleMeasureElement = function (rect) {
      var onMeasureElement = _this.props.onMeasureElement;

      if ((0, _lodash.isFunction)(onMeasureElement)) {
        onMeasureElement(rect);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Title, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          onMeasureElement = _this$props2.onMeasureElement,
          title = _this$props2.title;
      return _react.default.createElement(_reactMeasure.default, {
        bounds: true,
        client: true,
        onResize: function onResize(contentRect) {
          return _this2.handleMeasureElement(contentRect);
        },
        scroll: true
      }, function (_ref) {
        var measureRef = _ref.measureRef;
        return _react.default.createElement("h1", {
          className: (0, _classnames.default)('title green content-width', className),
          ref: measureRef,
          style: style
        }, title);
      });
    }
  }]);
  return Title;
}(_react.default.Component);

Title.defaultProps = {
  onMeasureElement: null,
  title: ''
};
var _default = Title;
exports.default = _default;